$shm_hitalama_resilience_page $mol_page
	title \Раздел временно недоступен
	message \Не удалось загрузить данные. Остальные разделы продолжают работать.
	details \
	retry_visible true
	head /
		<= Title $mol_view
			sub / <= title
	body /
		<= Content $mol_view
			sub /
				<= Message $mol_text
					text <= message
				<= Details $mol_text
					text <= details
				<= Retry_visible $mol_view
					sub <= retry_controls /
						<= Retry $mol_button_major
							title \Повторить загрузку
							click? <=> retry? null
